<div class="dialog-body">
  <div class="dialog-content">
    Please save order analysis and classes in OPSI to generate a preview.
  </div>
  <mat-dialog-actions align="end">
    <button
      mat-stroked-button
      color="primary"
      class="cdx-but-lg"
      mat-dialog-close
    >
      Close
    </button>
  </mat-dialog-actions>
</div>
